import { render, staticRenderFns } from "./_cancelledBetList.vue?vue&type=template&id=1c11aa20&scoped=true&lang=pug&"
import script from "./_cancelledBetList.vue?vue&type=script&lang=js&"
export * from "./_cancelledBetList.vue?vue&type=script&lang=js&"
import style0 from "./_cancelledBetList.vue?vue&type=style&index=0&id=1c11aa20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c11aa20",
  null
  
)

export default component.exports